import { OK } from 'http-status-codes'
import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'

class CpaAbandonada {
  constructor (args = {}) {
    Object.keys(args).forEach(key => { this[key] = args[key] })
  }

  save () {
    const axios = getAxiosInstance()
    const promise = axios.post(`carta_de_porte_automotor_abandonada`,
      `{"valores": {"numero": "${this.numero}", "motivo_abandono": "${this.motivoAbandono}"}}`)

    return promise.then(lrsAdapter, lrsAdapter)
  }

  getCpaAbandonada () {
    const axios = getAxiosInstance()
    const orden = '{"orden": ["d:fecha_de_abandono"]}'
    const promise = axios.get(`consulta_cpa_abandonada?r=${orden}`)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el listado de camiones abandonados.')
      return data
    })
  }

  desAbandonar () {
    const axios = getAxiosInstance()
    const cpa = `{"clave":{"numero":" ${this.numero}"}}`
    const promise = axios.delete(`carta_de_porte_automotor_abandonada?r=${cpa}`)

    return promise.then(lrsAdapter, lrsAdapter)
  }
}

export default CpaAbandonada
